import request, { post, get } from "@/utils/request";

// 登录接口
export function login(params) {
    const data = {
        username: params.username,
        password: params.password
    };
    return request({
        url: '/system/webAuth/login',
        method: 'post',
        data: data
    })
}

// 获取用户信息接口
export function getUser() {
    return request({
        url: '/system/auth/get-permission-info',
        method: 'get'
    });
}

// 获取用户信息接口
export function getUserInfo() {
    return request({
        url: '/system/webAuth/get-user-info',
        method: 'get'
    });
}

// 退出接口
export function logout() {
    return request({
        url: '/system/auth/logout',
        method: 'post'
    });
}

// 获取用户信息接口
export function getProfileUserInfo(id) {
    return request({
        url: '/system/hdjg/user/get?id=' + id,
        method: 'get',
    });
}

// 修改用户个人信息
export function updateUserProfile(data) {
    return request({
        url: '/system/hdjg/user/update',
        method: 'put',
        data: data
    })
}

// 用户密码重置
export function updateUserPwd(oldPassword, newPassword) {
    const data = {
        oldPassword,
        newPassword
    }
    return request({
        url: '/system/hdjg/user/update-password',
        method: 'put',
        data: data
    })
}

// 用户头像上传
export function uploadAvatar(data) {
    return request({
        url: '/system/hdjg/user/update-avatar',
        method: 'put',
        data: data
    })
}